export const LOADING_PERIOD_CONFIG = "LOADING_PERIOD_CONFIG";
export const SAVE_LOADING_PERIOD_CONFIG = "SAVE_LOADING_PERIOD_CONFIG";
export const GET_PERIOD_CONFIG = "GET_PERIOD_CONFIG";
export const FORM_FAIL = "FORM_FAIL";
export const PERIOD_CONFIG_FAIL = "PERIOD_CONFIG_FAIL";
export const LOADING_PERIOD_CONFIG_BY_ID = "LOADING_PERIOD_CONFIG_BY_ID";
export const GET_PERIOD_CONFIG_BY_ID = "GET_PERIOD_CONFIG_BY_ID";

